import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { useGet, usePost } from '@/utils/request';
export function getCaptcha() {
  return _getCaptcha.apply(this, arguments);
}
function _getCaptcha() {
  _getCaptcha = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", useGet('/web/captcha'));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getCaptcha.apply(this, arguments);
}
export function loginApi(_x) {
  return _loginApi.apply(this, arguments);
}
function _loginApi() {
  _loginApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(param) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", usePost('/web/login', param));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _loginApi.apply(this, arguments);
}
export function regApi(_x2) {
  return _regApi.apply(this, arguments);
}
function _regApi() {
  _regApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(param) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", usePost('/web/reg', param));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _regApi.apply(this, arguments);
}
export function modifyPsdApi(_x3) {
  return _modifyPsdApi.apply(this, arguments);
}
function _modifyPsdApi() {
  _modifyPsdApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(param) {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", usePut('/web/modifyPsd', param));
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _modifyPsdApi.apply(this, arguments);
}
export function sendCaptchaApi(_x4) {
  return _sendCaptchaApi.apply(this, arguments);
}
function _sendCaptchaApi() {
  _sendCaptchaApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(email) {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", usePost('/web/sendCode', {
            email: email
          }));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _sendCaptchaApi.apply(this, arguments);
}